<template>

	<v-card
		color="brightBackground"
		flat
		tile
		height="100%"
	>

		<v-container fluid style="max-width: 1000px;">

			<!-- Form -->
			<v-form ref="newCustomerForm">

			<v-row>

				<v-col
					align="center"
					justify="center"
				>
					<v-row no-gutters>
						<v-subheader class="display-1 font-weight-bold pl-3 mt-5 ml-0 mb-3 pb-5 grey--text text--darken-3">Create user</v-subheader>
					</v-row>

					<v-row no-gutters>

						<v-col cols="12" md="12" lg="6" xl="6" class="px-3">
							<v-text-field
								label="First name"
								v-model="userData.firstName"
								outlined
								dense
							></v-text-field>
						</v-col>


						<v-col cols="12" md="12" lg="6" xl="6" class="px-3">
							<v-text-field
								label="Last name *"
								v-model="userData.lastName"
								:rules="agile.fieldRules.nameRules"
								outlined
								dense
								required
								validate-on-blur
							></v-text-field>
						</v-col>

					</v-row>

					<v-row no-gutters>

						<v-col cols="12" md="12" lg="6" xl="6" class="px-3">
							<v-text-field
								label="Email *"
								v-model="userData.email"
								:rules="agile.fieldRules.emailRules"
								outlined
								dense
								required
								validate-on-blur
							></v-text-field>
						</v-col>


					</v-row>


						<v-row no-gutters>

						<v-col cols="12" md="12" lg="6" xl="6" class="px-3">
							<v-text-field
								:label="(passwordGenerationType == 'auto_generated') ? '' : 'Password *'"
								v-model="userData.password"
								required
								outlined
								dense
								validate-on-blur
								:disabled="passwordGenerationType == 'auto_generated'"
								:rules="(passwordGenerationType == 'user_defined') ? agile.fieldRules.passwordRules : [true]"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="12" lg="6" xl="6" class="px-3 mt-n0">
							<v-radio-group v-model="passwordGenerationType" :mandatory="true" row class="mt-1">
								<v-radio label="Define password" value="user_defined"></v-radio>
								<v-radio label="Auto generate password" value="auto_generated"></v-radio>
							</v-radio-group>
						</v-col>

					</v-row>
					


					<v-row no-gutters>

						<v-col align="right">
							<v-btn color="iconTextColor" class="mr-3" small text router to="/admin/users/active">
								<v-icon medium class="pr-1">mdi-cancel</v-icon>
								Cancel
							</v-btn>
							<v-btn color="iconTextColor" class="mr-3" small text @click="createUser">
								<v-icon medium class="pr-1">mdi-account-check</v-icon>
								Create user
							</v-btn>
						</v-col>
						
					</v-row>

				</v-col>

			</v-row>

			</v-form>

		</v-container>
	</v-card>

</template>




<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import fb from '@/shift/fb';


export default
{
	name: 'NewUser',

	// ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		passwordGenerationType: 'auto_generated',

		userData:
		{
			displayName: '',
			firstName: '',
			lastName: '',
			email: '',
			disabled: false,
		},
		
	}),

	computed:
	{
		// Get agile for the field rules (for validating)
		agile()
		{
			return agile;
		},
		
	},


	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		
	},

	mounted()
	{
		
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Methods
	//
	// --------------------------------------------------------------------

	methods:
	{
		// ----------------------------------
		//	Form validation
		// ----------------------------------
		
		validateUserForm()
		{
			return this.$refs.newCustomerForm.validate();
		},

		resetValidation()
		{
			this.passwordGenerationType = 'auto_generated';
			this.$refs.newCustomerForm.resetValidation();
		},


		createUser()
		{
			if (this.validateUserForm())
			{
				this.userData.name = this.userData.firstName+" "+this.userData.lastName;

				this.$root.ai_app.showProgressWheel = true;

				// ----------------------------------
				//	Create user
				// ----------------------------------

				let usePass = (this.passwordGenerationType == "auto_generated") ? "test1234" : this.userData.password ;
				console.log("* Password is set to", usePass);
				//console.log("*C Disabled:", this.userData.disabled)
				
				const createUser = fb.functions.httpsCallable('createUser');

				createUser( { email:this.userData.email, password:usePass, firstName:this.userData.firstName, lastName:this.userData.lastName, disabled:this.userData.disabled } )
				.then(result =>
				{
					if (result.data.success)
					{
						this.$root.ai_app.snackbarText = 'User created';
						this.$root.ai_app.snackbarTimeout = 4000;
						this.$root.ai_app.snackbar = true;
						this.$router.push('/admin/users/active');
					}
					else
					{
						this.$root.$alert("Error", result.data.error.message);
						this.errorText = result.data.error.message;
						
					}
					
					this.$root.ai_app.showProgressWheel = false;
					
				})
				.catch(er =>
				{
					this.$root.$alert("Error", er.message);
					this.$root.ai_app.showProgressWheel = false;
				});

					
				
				
			}
		},

	},



	// ----------------------------------
	//	VUE: Components
	// ----------------------------------

	components:
	{
		
	}

}
</script>